// Client Form Schema for FormBuilder
export const createClientSchema = {
  initialValues: {
    name: '',
    email: '',
    phone: '',
    is_active: true,
    notes: '',
    billing_info: [] // Array of billing info sets (includes city/country)
  },
  
  validationRules: {
    name: {
      required: true,
      minLength: 2,
      message: 'Το όνομα είναι υποχρεωτικό (τουλάχιστον 2 χαρακτήρες)'
    },
    email: {
      required: true,
      email: true,
      message: 'Παρακαλώ εισάγετε έγκυρο email'
    },
    phone: {
      required: true,
      minLength: 10,
      message: 'Το τηλέφωνο πρέπει να έχει τουλάχιστον 10 ψηφία'
    }
  },
  
  sections: [
    {
      title: 'Βασικά Στοιχεία',
      fields: [
        {
          name: 'name',
          label: 'Όνομα Πελάτη',
          type: 'text',
          required: true,
          size: 6
        },
        {
          name: 'email',
          label: 'Email',
          type: 'email',
          required: true,
          size: 6
        },
        {
          name: 'phone',
          required: true,
          label: 'Τηλέφωνο',
          type: 'tel',
          size: 6
        }
      ]
    },
    {
      title: 'Επιχειρηματικά / Φορολογικά Στοιχεία',
      customComponent: 'BillingInfoSection', // Custom component for billing info
      fields: [] // Fields will be handled by custom component
    },
    {
      title: 'Επιπλέον Πληροφορίες',
      fields: [
        {
          name: 'is_active',
          label: 'Ενεργός Πελάτης',
          type: 'checkbox',
          size: 6
        },
        {
          name: 'notes',
          label: 'Σημειώσεις',
          type: 'text',
          multiline: true,
          rows: 3,
          size: 12
        }
      ]
    }
  ]
};

export const updateClientSchema = {
  ...createClientSchema,
  // Same schema for updates
};